import { render } from "./reserve-list.vue?vue&type=template&id=20238219&scoped=true"
import script from "./reserve-list.vue?vue&type=script&lang=js"
export * from "./reserve-list.vue?vue&type=script&lang=js"

import "./reserve-list.vue?vue&type=style&index=0&id=20238219&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20238219"]])

export default __exports__